import Accordion from '@/common/components/Accordion'
import InfoField from '@/common/components/InfoField'
import { EquipmentModelLatestFipeDataDimensions } from '@/features/equipments/types/equipmentModelLatestFipe'

interface FipeDimensionsAccordionProps {
  dimensionsData?: EquipmentModelLatestFipeDataDimensions
}

export default function FipeDimensionsAccordion({ dimensionsData }: FipeDimensionsAccordionProps) {
  return (
    <Accordion
      name="Dimensions"
      head="Dimensões"
      body={
        <div className="flex flex-col gap-1">
          <div className='flex items-center gap-1'>
            <InfoField label="Comprimento" value={dimensionsData?.Comprimento} />
            <InfoField label="Largura" value={dimensionsData?.Largura} />
            <InfoField label="Altura" value={dimensionsData?.Altura} />
          </div>
          <div className='flex items-center gap-1'>
            <InfoField label="Distância Entre Eixos" value={dimensionsData?.["Distancia Entre Eixos"]} />
            <InfoField label="Bitola Dianteira" value={dimensionsData?.["Bitola Dianteira"]} />
            <InfoField label="Bitola Traseira" value={dimensionsData?.["Bitola Traseira"]} />
          </div>
          <div className='flex items-center gap-1'>
            <InfoField label="Porta Malas" value={dimensionsData?.["Porta Malas"]} />
            <InfoField label="Tanque Combustível" value={dimensionsData?.["Tanque Combustivel"]} />
            <InfoField label="Carga Útil" value={dimensionsData?.["Carga Util"]} />
          </div>
          <div className='flex items-center gap-1'>
            <InfoField label="Altura Mínima do Solo" value={dimensionsData?.["Altura Minima Do Solo"]} />
            <InfoField label="Reboque Sem Freio" value={dimensionsData?.["Reboque Sem Freio"]} />
            <InfoField label="Reboque Com Freio" value={dimensionsData?.["Reboque Com Freio"]} />
          </div>
          <div className='flex items-center gap-1'>
            <InfoField label="Ângulo Entrada" value={dimensionsData?.["Angulo Entrada"]} />
            <InfoField label="Ângulo Saída" value={dimensionsData?.["Angulo Saida"]} />
            <InfoField label="Ângulo Central" value={dimensionsData?.["Angulo Central"]} />
          </div>
          <div className='flex items-center gap-1'>
            <InfoField label="Travessia Água" value={dimensionsData?.["Travessia Agua"]} />
            <InfoField label="Rampa Máxima" value={dimensionsData?.["Rampa Maxima"]} />
            <InfoField label="Inclinação Lateral Máxima" value={dimensionsData?.["Inclinacao Lateral Maxima"]} />
          </div>
          <div className='flex items-center gap-1'>
            <InfoField label="Caçamba" value={dimensionsData?.Cacamba} />
            <InfoField label="Porta Malas 5 Lugares" value={dimensionsData?.["Porta Malas5 Lugares"]} />
            <InfoField label="Porta Malas 6 Lugares" value={dimensionsData?.["Porta Malas6 Lugares"]} />
          </div>
          <div className='flex items-center gap-1'>
            <InfoField label="Porta Malas 7 Lugares" value={dimensionsData?.["Porta Malas7 Lugares"]} />
            <InfoField label="Porta Malas 8 Lugares" value={dimensionsData?.["Porta Malas8 Lugares"]} />
          </div>
        </div>
      }
    />
  )
}